module.exports = __webpack_public_path__ + "img/icono-amarillo_.3dc3f9e1.png";